import Reflux from "reflux";

export default Reflux.createActions({
  setSandboxValue: {},
  storeSandboxData: {},
  clearSandbox: {}
});
